module.exports = __webpack_public_path__ + "media/images/img-pet-8-d5207a0e.jpg";